export default "__VITE_ASSET__Uo1_OHTd__"